import { QueryKey } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';
import { ParentLocation } from '../types/shipments';

export const router = createRouter({
	routeTree,
	context: {
		// biome-ignore lint/style/noNonNullAssertion: Following Tanstack Router Documentation (https://tanstack.com/router/latest/docs/framework/react/examples/authenticated-routes).
		auth: undefined!,
		// biome-ignore lint/style/noNonNullAssertion: Following Tanstack Router Documentation (https://tanstack.com/router/latest/docs/framework/react/examples/authenticated-routes).
		queryClient: undefined!,
	},
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}

	/** For now, this is global and cannot be typed per route until
	 * [Tanstack Router V2](https://github.com/TanStack/router/discussions/284#discussioncomment-9344482). */
	interface HistoryState {
		/** Used to derived next and previous shipment detail navigation. */
		parentQueryKey?: QueryKey;
		/** Used to derive back navigation back to shipments list with preserved filters. */
		parentLocation?: ParentLocation;
	}
}
